/* eslint-disable */
(function (jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.now_mastheads = {
    attach: function (context, settings) {

      once('now-masthead-init', '.lb-section--masthead', context).forEach(function() {
        const mastheadSlideSelector = '.block-nowfoods-masthead-block';
        const $mastheadWrapper = jQuery('.lb-section--masthead');
        const $mastheadSlider = $mastheadWrapper.find('.lb-region--main');
        let $mastheadSlides = $mastheadSlider.find(mastheadSlideSelector);
        let $slickDots;
        let newTransition;
        const $body = jQuery('body');

        const pauseMastheadSlider = function() {
          const $playBtn = $mastheadWrapper.find('.slick-play-pause');
          const $playBtnIcon = $playBtn.find('i');
          const $activeDot = $mastheadWrapper.find('.slick-dots .slick-active');
          const $activeButton = $activeDot.find('button');

          $activeDot.parent().removeClass('slider-play');
          // Update the button
          $mastheadSlider.slick('slickPause');
          $playBtn.attr('aria-label', 'play slider');
          // Set slider state
          $mastheadSlider.attr('data-slick-state', 'pause');
          /**
           * Set the max-width in place to pause the progress-bar effect.
           * Update the transition-duration
           * to take the remaining space in the remaining time.
           */
          const w = $activeButton.width();
          const progress = w / $activeDot.width(); // decimal percentage
          const remaining = 1 - progress;
          const oldTransition = parseFloat($activeButton.css('transition-duration'));
          newTransition = (remaining * oldTransition);
          newTransition = Math.floor(newTransition * 1000) / 1000;
          $activeButton.css({ 'max-width': w + 'px', 'transition-duration': newTransition + 's' });
          $playBtnIcon.addClass('fa-play-circle');
          $playBtnIcon.removeClass('fa-pause-circle');
        };

        const playMastheadSlider = function() {
          const $playBtn = $mastheadWrapper.find('.slick-play-pause');
          const $playBtnIcon = $playBtn.find('i');
          $mastheadSlider.slick('slickPlay');
          // $mastheadSlider.slick('slickNext');
          const $activeDot = $mastheadWrapper.find('.slick-dots .slick-active');
          const $activeButton = $activeDot.find('button');

          $activeDot.parent().addClass('slider-play');
          if ($mastheadWrapper.hasClass('init-untouched')) {
            $mastheadWrapper.removeClass('init-untouched');
            $activeDot.removeClass('slick-active');
            setTimeout(function() {
              $activeDot.addClass('slick-active');
            }, 10);
          }
          // Update the button
          $playBtn.attr('aria-label', 'pause slider');
          // Set the slider state
          $mastheadSlider.attr('data-slick-state', 'play');
          /**
           * Remove the max-width to resume progress
           * Remove the duration override after it completes
           */
          $activeButton.css({ 'max-width': '' });
          setTimeout(function() {
            $activeButton.css({ 'transition-duration': '' });
          }, newTransition * 1000);
          $playBtnIcon.removeClass('fa-play-circle');
          $playBtnIcon.addClass('fa-pause-circle');
        };

        const playButtonToggle = function() {
          const currentState = $mastheadSlider.attr('data-slick-state');

          if (currentState === 'play') {
            pauseMastheadSlider();
          }
          else {
            playMastheadSlider();
          }
        };

        const hideOffscreenTabbables = function() {
          const tabbableElements = 'a, button, input, select, textarea, iframe, area, [contentEditable=true]';
          jQuery('.slick-slide').find(tabbableElements).attr('tabindex', -1);
          jQuery('.slick-slide.slick-active').find(tabbableElements).attr('tabindex', 0);
        };

        const fixSliderButtonTabIndex = function() {
          setTimeout(function() {
            $mastheadWrapper.find('.slick-dots button[tabindex="-1"]').attr('tabindex', 0);
          }, 20);
        };

        const mastheadSliderInit = function() {

          if ($mastheadSlides.length > 1 && !$mastheadSlider.hasClass('slick-initialized') && !$body.hasClass('admin-layout-builder-overrides')) {

            const $slideControls = jQuery('<div class="masthead-slide-controls"></div>');
            const $slickPlayPause = jQuery('<button class="slick-play-pause" aria-label="play slider"><i class="far fa-play-circle"></i></button>');
            $slickPlayPause.click(function() {
              fixSliderButtonTabIndex();
              playButtonToggle();
            });
            $slideControls.append($slickPlayPause);
            if (!($mastheadWrapper.find('.masthead-slide-controls').length > 0)) {
              $mastheadWrapper.append($slideControls);
            }

            $mastheadSlider
              .on('init', function (event, slick) {
                $mastheadWrapper.addClass('init-untouched');
                $slickDots = jQuery('.lb-section--masthead .slick-dots button');
                $slickDots.on('click', function() {
                  fixSliderButtonTabIndex();
                  setTimeout(function() {
                    pauseMastheadSlider();
                  }, 10);
                });
                // Initial state: paused
                $mastheadSlider.attr('data-slick-state', 'pause');
                // show controls
                $mastheadWrapper.find('.masthead-slide-controls').addClass('init');
                fixSliderButtonTabIndex();
              })
              .on('beforeChange', function (event, { slideCount: count }, currentSlide, nextSlide) {
                $mastheadWrapper.find('.slick-dots button').css({ 'max-width': '', 'transition-duration': '' });
              })
              .on('afterChange', function (event, slick, currentSlide, nextSlide) {
                fixSliderButtonTabIndex();
                hideOffscreenTabbables();
                if (window.bLazy) {
                  window.bLazy.revalidate();
                }
              })
              .slick({
                rows: 0,
                infinite: true,
                slidesToShow: 1,
                dots: true,
                arrows: false,
                autoplay: false,
                speed: 400,
                autoplaySpeed: 3500, // must match mastheads.scss $slide-speed for progress bars to work
                appendDots: '.lb-section--masthead .masthead-slide-controls',
                cssEase: 'ease',
                slide: mastheadSlideSelector,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false
              });
          }
          hideOffscreenTabbables();
        };
        mastheadSliderInit();
      });
    }
  };
})(jQuery, Drupal);
